function authFailureStatus(error) {
    return error?.statusCode
        ?? error?.status
        ?? error?.response?.status
        ?? error?.original?.statusCode
        ?? error?.original?.status
        ?? error?.original?.response?.status;
}

export function authFailureInvalidatesSession(error, currentToken) {
    if (!currentToken) return true;
    return authFailureStatus(error) === 401;
}
